import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect } from "react";
import HomePage from "./pages/HomePage";
import LoginForm from "./components/Layout/LoginForm";
import { useNavigate } from "react-router-dom";
import PreventLogin from "./pages/PreventLogin";
import { db } from "./FirebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";
import {
  SendPushNotification,
  getFCM,
} from "./components/SendPushNotification";

const App = () => {
  // const uids = [87]

  // useEffect(() => {
  //   for (let index = 0; index < uids.length; index++) {
  //     getFCM(uids[index])
  //   }
  // }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route
          path="/dashboard/*"
          element={
            <PreventLogin>
              <HomePage />
            </PreventLogin>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
